import React, { useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../../common/modal/index";
import api from '../../../services/axios';
import { useJWTAuth } from '../../../services/JWTAuthProvider';
import Swal from "sweetalert2";

const BulkAccess = ({ isOpen, selectedUser, closeCallback, successCallBack }) => {
    const [ setFileName] = useState(null);
    const [ setFileType] = useState(null);
    const [ setFileArray] = useState(null);
    const [selectedFolders, setSelectedFolders] = useState([]);
    const [subBtnDisabled, setSubBtnDisabled] = useState(false);
    const { user } = useJWTAuth();
    const userInfo = user;


    const [folderList, setFolderList] = React.useState([]);
    React.useEffect(() => {
        const getData = async () => {
            try {
                const { data } = await api.get("/Folders/getrootfolders?Id=" + userInfo.id);
                setFolderList(data.result.folders);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        getData();
    }, []);

    const handleFolderSelection = (folder) => {
        // Add or remove the selected folder from the array
        setSelectedFolders((prevSelected) => {
            if (prevSelected.includes(folder)) {
                return prevSelected.filter((item) => item !== folder);
            } else {
                return [...prevSelected, folder];
            }
        });
    };


    const handleSelectAllFolders = (e) => {
        if (e.target.checked) {
            // Select all folders
            setSelectedFolders(folderList.map(li => li.folderIdentifier));
        } else {
            // Deselect all folders
            setSelectedFolders([]);
        }
    };

    const handleSubmit = async () => {

        if (selectedFolders.length === 0) {
            Swal.fire({
                position: "center",
                icon: "info",
                text: "Please select atleast one folder",
                showConfirmButton: true,
                timer: 3000,
                timerProgressBar: true
            });
        }
        else {
            setSubBtnDisabled(true)
            if (selectedUser.length > 0) {
                let jsonData = selectedUser;
                jsonData.map((e) => e.folders = selectedFolders);
                jsonData = jsonData.map(({ uniqueIdentifier, folders }) => ({ uniqueIdentifier, folders }));
                try {
                    const { data } = await api.post('/User/BulkAccess', jsonData);
                    if (data.statusCode === 200) {
                        closeCallback();
                        if (successCallBack)
                            successCallBack();
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            text: "Bulk Access process done successfully",
                            showConfirmButton: true,
                            timer: 3000,
                            timerProgressBar: true
                        });
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }
            else {
                Swal.fire({
                    position: "center",
                    icon: "info",
                    text: 'Please select at least one user',
                    showConfirmButton: true,
                    timer: 3000,
                    timerProgressBar: true
                });
            }
        }
        setSubBtnDisabled(false)
    }

    return (
        <Modal isLarge={false} isOpen={isOpen}>
            <ModalHeader>
                <h5 className="modal-title" id="exampleModalLabel">
                    <img src="/Assets/folder-icon.svg" alt='Bulk access' /> Assign Access
                </h5>
            </ModalHeader>
            <ModalBody>
                <label class="form-label">Select Folder</label>
                <div className='select-folder'>
                    <div className='folder-check-wrap'>
                        <div className='all-check'>
                            <input type="checkbox" id='all' onChange={handleSelectAllFolders} /> <label for="all">Select All Folders</label>
                        </div>
                        {folderList.map((folder) => (

                            <div className='single-check'>
                                <input type="checkbox" id={folder.folderIdentifier} checked={selectedFolders.includes(folder.folderIdentifier)} onChange={() => handleFolderSelection(folder.folderIdentifier)} /> <label for={folder.name} ><img src="../Assets/folder-icon.svg" alt='User' /> {folder.name}</label>
                            </div>
                        ))}

                    </div>
                </div>

            </ModalBody>
            <ModalFooter>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeCallback}
                >
                    Cancel
                </button>
                <button disabled={subBtnDisabled} type="button" onClick={handleSubmit} className="btn btn-primary">
                    Submit
                </button>
            </ModalFooter>
        </Modal>);
};
export default BulkAccess;